import { Box, useTheme } from '@mui/material';
import React from 'react';
import unauth_background from '../assets/unauth_background.png'
import { useTranslation } from 'react-i18next';

interface AnonymousLayoutProps {
    children?: React.ReactNode;
}
const AnonymousLayout: React.FC<AnonymousLayoutProps> = ({ children }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return <Box display={"flex"} height={"100%"} width={"100%"} justifyContent={"stretch"} alignItems={"stretch"} bgcolor={theme.palette.background.default}>
        <Box display={"flex"} width={"44.7%"} justifyContent={"center"} alignItems={"stretch"} bgcolor={theme.palette.common.white}>
            {children}
        </Box>
        <Box display={"flex"} alignItems={"center"} flexGrow={1} justifyContent={"end"}>
            <img src={unauth_background} style={{maxHeight: "90vh", maxWidth: "50vw"}} alt={t('A11yAuthBackground')} />
        </Box>
    </Box>
}

export default AnonymousLayout;

/*<Box height={"100%"} width={"100%"} display={"flex"} padding={"20px"} overflow={"auto"} flexDirection={"column"} alignItems={"center"} justifyContent={"start"} gap={"20px"} bgcolor={theme.palette.primary.main}>
        prout
        {children}
    </Box>*/